import { getDaysFromHistory } from "@intelligems/ig-analytics";
import { ExperienceActionDto } from "@intelligems/ig-types";

/** Minimum active runtime, in days, below which a test is "short-running". */
export const EARLY_TEST_MIN_RUNTIME_DAYS = 1;

export interface EarlyTestRuntimeInput {
  experienceActions?: ExperienceActionDto[] | null;
}

export interface EarlyTestRuntimeResult {
  daysLive: number;
  isShortRunning: boolean;
}

/**
 * A test is short-running when its live runtime (paused time excluded, via the
 * shared {@link getDaysFromHistory}) is under {@link EARLY_TEST_MIN_RUNTIME_DAYS}.
 * `nowMs` is injectable so tests can pass a stable clock.
 */
export const isShortRunningTest = (
  experience: EarlyTestRuntimeInput,
  nowMs?: number
): EarlyTestRuntimeResult => {
  const daysLive = getDaysFromHistory(
    experience.experienceActions ?? [],
    nowMs
  );

  return {
    daysLive,
    isShortRunning: daysLive < EARLY_TEST_MIN_RUNTIME_DAYS,
  };
};
